import React, { useState } from "react";
import { Link } from "react-router-dom";
// import logo from "./logo512.png";

const AdminPanel = () => {
    const [showDropdown, setShowDropdown] = useState(false);

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    const handleLogout = () => {
        // handle logout logic here
    };

    return (
        <div className="admin-panel">
            <div className="top-bar">
                {/*<div className="logo">*/}
                {/*    <img src={logo} alt="Logo" />*/}
                {/*</div>*/}
                <div className="admin">
                    <div className="name" onClick={toggleDropdown}>
                        John Doe
                        <i className="fas fa-caret-down"></i>
                    </div>
                    {showDropdown && (
                        <div className="dropdown">
                            <ul>
                                <li>
                                    <Link to="/profile">Profile</Link>
                                </li>
                                <li>
                                    <a href="#" onClick={handleLogout}>
                                        Logout
                                    </a>
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
            </div>
            <div className="sidebar">
                <ul>
                    <li>
                        <Link to="/users">
                            <i className="fas fa-userss"></i>
                            Users
                        </Link>
                    </li>
                    <li>
                        <Link to="/companies">
                            <i className="fas fa-building"></i>
                            Companies
                        </Link>
                    </li>
                    <li>
                        <Link to="/factories">
                            <i className="fas fa-industry"></i>
                            Factories
                        </Link>
                    </li>
                    <li>
                        <Link to="/repair-requests">
                            <i className="fas fa-wrench"></i>
                            Repair Requests
                        </Link>
                    </li>
                </ul>
            </div>
            <div className="content">
                <h1>Welcome to the User Panel</h1>
            </div>
        </div>
    );
};

export default AdminPanel;
